import { CommonModule } from '@angular/common'
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconModule } from '@angular/material/icon'
import { NbButtonModule, NbInputModule } from '@nebular/theme'
import { NgxTippyModule } from 'ngx-tippy-wrapper'
import { SavedFilter } from '../../models/saved-filter.interface'

@Component({
  selector: 'app-saved-filters-dropdown',
  templateUrl: './saved-filters-dropdown.component.html',
  styleUrls: ['./saved-filters-dropdown.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, NbButtonModule, NbInputModule, NgxTippyModule]
})
export class SavedFiltersDropdownComponent {
  @ViewChild('triggerBtn') triggerBtn: ElementRef

  @Input() savedFilters: SavedFilter[] = []
  @Input() hasActiveFilters = false

  @Output() filterSelected = new EventEmitter<SavedFilter>()
  @Output() filterDeleted = new EventEmitter<string>()
  @Output() saveRequested = new EventEmitter<string>()

  isOpen = false
  isSaveMode = false
  newFilterName = ''
  dropdownTop = 0
  dropdownLeft = 0

  toggle(): void {
    if (!this.isOpen) {
      this.calculatePosition()
    }
    this.isOpen = !this.isOpen
    if (!this.isOpen) {
      this.isSaveMode = false
      this.newFilterName = ''
    }
  }

  private calculatePosition(): void {
    if (!this.triggerBtn?.nativeElement) return
    const rect = this.triggerBtn.nativeElement.getBoundingClientRect()
    this.dropdownTop = rect.bottom + 8
    this.dropdownLeft = Math.max(8, rect.right - 300) // 300 is dropdown width
  }

  close(): void {
    this.isOpen = false
    this.isSaveMode = false
    this.newFilterName = ''
  }

  selectFilter(filter: SavedFilter): void {
    this.filterSelected.emit(filter)
    this.close()
  }

  deleteFilter(event: Event, filterId: string): void {
    event.stopPropagation()
    this.filterDeleted.emit(filterId)
  }

  showSaveMode(): void {
    this.isSaveMode = true
    this.newFilterName = ''
  }

  cancelSave(): void {
    this.isSaveMode = false
    this.newFilterName = ''
  }

  saveFilter(): void {
    if (this.newFilterName.trim()) {
      this.saveRequested.emit(this.newFilterName.trim())
      this.close()
    }
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr)
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  }

  getFilterSummary(filter: SavedFilter): string {
    const parts: string[] = []
    const filterCount = Object.keys(filter.filters.fieldFilters || {}).length
    if (filterCount > 0) {
      parts.push(`${filterCount} filter${filterCount > 1 ? 's' : ''}`)
    }
    if (filter.filters.searchTerm) {
      parts.push('search')
    }
    if (filter.filters.sortField) {
      parts.push('sorted')
    }
    return parts.join(', ') || 'No filters'
  }
}
